<template>
  <div class="orders">
    <div class="page-header">
      <i class="iconfont icon-back" @click="goBack">&#xe615;</i>
      <div class="page-title">我的订单</div>
      <i class="iconfont"></i>
    </div>
    <div class="swiper-tab">
      <div
        @click="filterBy(item.code)"
        :class="[status == item.code ? 'active' : '', 'swiper-tab-list']"
        v-for="(item, index) in states"
        :key="index"
      >
        {{ item.label }}
      </div>
    </div>
    <div v-if="orderList.length">
      <div
        class="order-item"
        v-for="(orderItem, index) in orderList"
        :key="index"
      >
        <div class="order-title">
          <div class="left">
            <div class="order-type" v-if="orderItem.order_type">
              {{ orderItem.order_type }}
            </div>

            <div class="id" v-if="orderItem.rma_code">
              售后编号：{{ orderItem.rma_code }}
            </div>
            <div class="id" v-else>订单编号：{{ orderItem.id }}</div>
          </div>

          <div class="status">
            <span>{{ orderItem.rma_code ? "售后类型：" : "订单状态：" }} </span>
            {{ orderItem.status }}
          </div>
          <div class="time" v-if="!orderItem.rma_code">
            下单时间：{{ orderItem.time }}
          </div>
        </div>
        <div class="order-content">
          <template v-if="isH5">
            <div
              class="order-info"
              @click="goDetail(orderItem)"
              style="cursor: pointer"
            >
              <div
                class="goods-item"
                v-for="(item, index) in orderItem.goods"
                :key="index"
              >
                <div class="item-img">
                  <img :src="item.cover" alt class="goods-pic" />
                  <!-- <span>{{item.status}}</span> -->
                  <span v-if="orderItem.status" class="order-status-babel">{{ orderItem.status }}</span>
                </div>
                <div class="item-right">
                  <div class="goods-info">
                    <!-- 品牌名：全局商品卡统一在 name 上方，样式对齐 ViewItemInfo -->
                    <div class="item-detail-brand" v-if="item.brand">{{ item.brand.name }}</div>
                    <span class="goods-name">{{ item.name }}</span>
                    <div class="goods-size">
                      <div style="margin-right: 30px">
                        颜色：{{ item.color.name }}
                      </div>
                      <div>尺码：{{ item.size }}</div>
                    </div>
                  </div>
                  <div class="goods-row">
                    <div class="num">x{{ item.quantity }}</div>
                    <div class="price">
                      <span class="rmb-symbol">￥</span>{{ item.price }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="order-info">
              <div
                class="goods-item"
                v-for="(item, index) in orderItem.goods"
                :key="index"
              >
                <div class="item-img">
                  <router-link :to="getProductRoutePath(item)">
                    <img :src="item.cover" alt class="goods-pic" />
                    <span v-if="item.status" class="order-status-babel">{{ item.status }}</span>
                  </router-link>
                </div>
                <div class="item-right">
                  <div class="goods-info">
                    <!-- 品牌名：全局商品卡统一在 name 上方，样式对齐 ViewItemInfo -->
                    <div class="item-detail-brand" v-if="item.brand">{{ item.brand.name }}</div>
                    <router-link :to="getProductRoutePath(item)" class="goods-name">{{
                      item.name }}</router-link>
                    <div class="goods-size">
                      <div style="margin-right: 30px">
                        颜色：{{ item.color.name }}
                      </div>
                      <div>尺码：{{ item.size }}</div>
                    </div>
                  </div>
                  <div class="goods-row">
                    <div class="num">x{{ item.quantity }}</div>
                    <div class="price">
                      <span class="rmb-symbol">￥</span>{{ item.price }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="order-summary" v-if="status === 'AfterSales'">
                <div class="summary-item">
                  申请件数: {{ calcQuantity(orderItem.goods) }} 件
                </div>
                <div class="summary-item price">
                  退款：{{ orderItem.refund_total_amount | filterPrice }}
                </div>
              </div>
              <div class="order-summary" v-else>
                <div class="summary-item">
                  共 {{ calcQuantity(orderItem.goods) }} 件
                </div>
                <div class="summary-item price">
                  总计：{{ orderItem.amount | filterPrice }}
                </div>
              </div>
            </div>
          </template>
          <div class="logistics-content">
            <div class="order-summary" v-if="isH5 && status === 'AfterSales'">
              <div class="summary-item">
                申请件数: {{ calcQuantity(orderItem.goods) }} 件
              </div>
              <div class="summary-item price">
                退款：{{ orderItem.refund_total_amount | filterPrice }}
              </div>
            </div>
            <div class="order-summary" v-if="isH5">
              <div class="summary-item">
                共 {{ calcQuantity(orderItem.goods) }} 件
              </div>
              <div class="summary-item price">
                总计：{{ orderItem.amount | filterPrice }}
              </div>
            </div>
            <div class="logistics-bottom">
              <div
                :class="[
                  'logistics-btn',
                  ele.buttonType,
                  ele.action === 'contact' ? 'udesk-go-service' : '',
                ]"
                v-for="(ele, index) in orderListItemButtonGroup(orderItem)"
                @click="orderAction(ele.action, orderItem)"
                :key="index"
              >
                {{ ele.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        :total="total"
        :limit="size"
        :current="page"
        @change="goPage"
      ></Pagination>
    </div>
    <!-- 订单为空 -->
    <div v-else>
      <div class="no-order">
        <div class="no-info">
          <div class="icon-wrapper">
            <i class="iconfont">&#xe670;</i>
          </div>
          <div class="no-txt">
            <div class="no-title">暂无订单</div>
            <div class="no-subtitle">您还没有相关订单</div>
          </div>
        </div>
        <div class="buy" @click="goShopping">去购物</div>
      </div>
    </div>

    <!-- 支付扫码弹窗 -->
    <div class="dialog wait-pay" v-if="orderInfo && orderInfo.payCode">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="hideWaitPayDialog"
            >&#xe61e;</i
          >
        </div>
        <div class="dialog-body">
          <div class="pay-method">
            <template
              v-if="
                orderInfo.paymentMethod == 1 || orderInfo.paymentMethod == 3
              "
            >
              <i class="iconfont ali-pay">&#xe600;</i>
            </template>
            <template v-else>
              <i class="iconfont wx-pay">&#xe62b;</i>
            </template>
            <span class="pay-name">{{
              ["", "支付宝", "微信支付", "支付宝", "微信支付", "微信支付"][
                orderInfo.paymentMethod
              ]
            }}</span>
          </div>
          <div class="pay-amount">
            支付金额：
            <span class="pay-value">
              <span class="rmb-symbol">￥</span> {{ orderInfo.amount }}
            </span>
          </div>
          <div class="pay-hits">
            <div class="pay-countdown">
              距离二维码过期还剩<span class="countdown"
                >{{ orderInfo.countdown.m }}分{{
                  orderInfo.countdown.s
                }}秒</span
              >
            </div>
            <div class="pay-msg">过期后请点击刷新重新获取二维码</div>
          </div>
          <div class="pay-code">
            <img :src="orderInfo.payCode" />
            <div
              v-if="orderInfo.codeMask"
              class="code-mask"
              @click="refreshPayCode"
            >
              <span>已失效</span>
            </div>
          </div>
          <div class="pay-method-tips">
            <div class="text">
              打开{{
                ["", "支付宝", "微信", "支付宝", "微信", "微信"][
                  orderInfo.paymentMethod
                ]
              }}扫一扫
            </div>
            <div class="text">扫描上方二维码完成付款</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付结果弹窗 -->
    <div class="dialog pay-unknown" v-if="payStatus == 'unknown'">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="closePayUnknown">&#xe61e;</i>
        </div>
        <div class="dialog-body">
          <div class="dialog-subtitle">支付结果</div>
          <div class="txt-line mt20">付款完成前请不要关闭窗口，</div>
          <div class="txt-line">完成付款后根据你的情况点击下方按钮！</div>
          <div class="btn-group">
            <button class="btn" @click="closePayUnknown">已完成支付</button>
            <button class="btn" @click="rePayment">
              支付遇到问题，重新支付
            </button>
          </div>
        </div>
      </div>
    </div>
    <TipDialog
      :visible="afterSalesExpiredTipDialogVisible"
      message="如您对商品售后有疑问，请联系在线客服处理"
      leftButtonText="取消"
      rightButtonText="联系客服"
      subtitle="抱歉，您的订单已过售后申请失效"
      @dialog-cancel="handleCloseTipDialog"
      type="udesk-go-service"
    />

    <TipDialog
      :visible="afterSalesConfirmReceiptTipDialogVisible"
      message="积分将在您确认收货后7个工作日发放"
      leftButtonText="取消"
      rightButtonText="联系客服"
      subtitle="请您确认收货"
      @dialog-cancel="handleCloseTipDialog"
      @dialog-confirm="confirmReceipt"
    />

    <AfterSaleDrawer
      v-if="showDrawer"
      title="退款申请流程"
      :initialData="{ ...currentItem, order_no: currentItem.id }"
      :orderId="currentItem.id"
      :visible.sync="showDrawer"
      @submit="handleSubmit"
      @close="handleDrawerClose"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
import { captureManualError } from "@/sentry/index";
import utilsOrder from "@/utils/order";
import TipDialog from "@/components/TipDialog.vue";
import AfterSaleDrawer from "@/components/afterSale/afterSaleDrawer.vue";

export default {
  components: { AfterSaleDrawer, Pagination, TipDialog },
  data() {
    return {
      states: utilsOrder.tabsLabel,
      allOrderStatus: utilsOrder.OrderStatus,
      currentTab: 0,
      status: "",
      page: 1,
      size: 10,
      total: 0,
      orderList: [],
      orderInfo: null,
      payStatus: "",
      showDrawer: false,
      afterSalesExpiredTipDialogVisible: false,
      afterSalesConfirmReceiptTipDialogVisible: false,
    };
  },
  created() {
    this.getOrderList();
  },
  methods: {
    // 状态过滤
    filterBy(state) {
      this.page = 1;
      this.status = state;
      if (state === "AfterSales") {
        this.getAfterSaleList();
      } else {
        this.getOrderList();
      }
    },
    // 加载订单列表
    getOrderList() {
      let { status, page, size } = this;
      api[types.ORDER_LIST]({ status, page, size })
        .then((res) => {
          if (res?.code == 1) {
            let { list, total } = res.data;
            this.orderList = list;
            this.total = total;
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err);
        });
    },
    getAfterSaleList() {
      let { page, size } = this;
      api[types.GET_AFTER_SALES_ORDER_LIST]({ page, pageSize: size })
        .then((res) => {
          if (res?.code == 1) {
            let { list, total } = res.data;
            const reList = list.map((item) => {
              return {
                ...item,
                time: item.created_at,
                status: item.chargeback_type,
              };
            });
            this.orderList = reList;
            this.total = total;
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err);
        });
    },
    // 页码变更
    goPage({ currPage }) {
      this.page = currPage;
      if (this.status === "AfterSales") {
        this.getAfterSaleList();
      } else {
        this.getOrderList();
      }
    },

    // 开始制定秒数的倒计时
    startCountdown(times, callback) {
      if (isNaN(times)) return console.warn(`倒计时参数错误: ${times}`), false;
      if (typeof callback != "function")
        return console.warn("缺少倒计时结束回调函数"), false;
      callback(times);
      let timer = setInterval(() => {
        times--;
        if (times <= 0) {
          timer && clearInterval(timer);
        }
        callback(times, timer);
      }, 1000);
      return timer;
    },
    // 继续支付：处理支付方式（沿用上次支付方式）
    toPay(info) {
      let paymentMethod = 1;
      if (utils.isWXBrowser()) {
        paymentMethod = 5;
      } else if (utils.isMobile()) {
        paymentMethod = info.payWay == "支付宝" ? 3 : 4;
      } else {
        paymentMethod = info.payWay == "支付宝" ? 1 : 2;
      }
      this.orderPay(info, paymentMethod);
    },
    // 订单支付
    orderPay(order, paymentMethod) {
      if (!order?.id)
        return console.warn(`缺少支付的订单号：(orderId: ${order?.Id})`), false;
      api[types.ORDER_PAY]({ orderId: order.id, paymentMethod: paymentMethod })
        .then((res) => {
          if (res?.code == 1) {
            if (paymentMethod == 1 || paymentMethod == 2) {
              let orderInfo = {
                id: order.id,
                goods: order.goods,
                amount: order.amount,
                shipping: order.shipping,
                paymentMethod: paymentMethod,
                payCode: res.data.url,
                codeMask: false,
              };
              // 4分钟倒计时
              this.wsInstance = null;
              let orderPayTimer = this.startCountdown(
                res.data.expire,
                (times, timer) => {
                  if (times > 0) {
                    orderInfo.countdown = {
                      m: Math.floor(times / 60),
                      s: times % 60,
                    };
                  } else {
                    timer && clearInterval(timer);
                    orderInfo.countdown = { m: 0, s: 0 };
                    orderInfo.codeMask = true;
                    this?.wsInstance?.close();
                  }
                }
              );
              this.orderPayTimer = orderPayTimer;
              // 查询支付状态
              this.checkOrderStatus(res.data?.id);
              this.showWaitPayDialog(orderInfo);
            } else {
              this.showPayUnknown(order.id);
              window.location.href = res?.data?.url;
            }
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err);
        });
    },
    // 刷新支付二维码
    refreshPayCode() {
      this.orderPay(this.orderInfo, this.orderInfo.paymentMethod);
    },
    // 显示支付窗口
    showWaitPayDialog(orderOpts) {
      this.orderInfo = orderOpts || null;
    },
    // 关闭支付窗口
    hideWaitPayDialog() {
      this.wsInstance?.close();
      this.orderPayTimer && clearInterval(this.orderPayTimer);
      this.orderInfo = null;
    },
    // 查询支付状态
    checkOrderStatus(id) {
      const intervalId = setInterval(() => {
        if (this.payStatus === "success") {
          clearInterval(intervalId);
          return;
        }
        api[types.ORDER_STATUS]({ id })
          .then((res) => {
            if (res.code === 1 && res.data.status === 1) {
              this.$message({ message: "支付成功" });
              this.payStatus = "success";
              this.hideWaitPayDialog();
              this.getOrderList();
              this.gaTrack4Purchase();
              intervalId && clearInterval(intervalId);
            }
          })
          .catch((err) => {
            captureManualError(err);
            console.error("查询支付状态失败:", err);
          });
      }, 3000);
      this.orderStatusTimer = intervalId;
    },
    // GA埋点
    gaTrack4Purchase() {
      const params = {
        send_to: process.env?.VUE_APP_GA4,
        currency: "CNY",
        transaction_id: this.orderInfo.id || this.$route.query.id,
        shipping: Number(this.orderInfo.shipping),
        value: Number(this.orderInfo.amount),
        items: this.orderInfo.goods.map((o) => ({
          item_id: o.style_number,
          item_name: o.name,
          price: Number(o.price),
          quantity: Number(o.quantity),
          item_brand: "Onitsuka Tiger",
          item_variant: o.color.name,
          currency: "CNY",
        })),
      };
      if (window.gtag) {
        window.gtag("event", "purchase", params);
      }
    },
    // 订单操作
    orderAction(action, orderItem) {
      this.currentItem = orderItem;
      if (action === "orderPay") {
        this.toPay(orderItem);
      } else if (action === "goDetail") {
        this.goDetail(orderItem);
      } else if (action === "applyAfterSales") {
        this.applyAfterSales(orderItem);
      } else if (action === "confirmReceipt") {
        this.confirmReceipt({ type: "confirmReceipt" });
      } else if (action === "goAfterSalesDetail") {
        this.goAfterSaleDetail(orderItem);
      }
    },

    handleDrawerClose() {
      this.showDrawer = false;
    },
    handleSubmit() {
      this.showDrawer = false;
    },
    // 售后申请
    applyAfterSales(orderItem) {
      const {
        is_rma,
        // time,
        status_code,
      } = orderItem || {};
      if (is_rma === 0) {
        this.afterSalesExpiredTipDialogVisible = true;
        return null;
      }
      const ramGoods = utils.filterRamGoods(orderItem);
      this.currentItem = { ...orderItem, goods: ramGoods };
      // 已发货的订单申请售后，需要先确认收货
      if (status_code === this.allOrderStatus.WAIT_BUYER_CONFIRM_GOODS) {
        this.afterSalesConfirmReceiptTipDialogVisible = true;
        return;
      } else {
        this.showDrawer = true;
      }
    },
    confirmReceipt(value) {
      const { type = "", orderItem = this.currentItem } = value || {};
      api[types.CONFIRM_RECEIPT]({ order_id: orderItem.id })
        .then(() => {
          this.$message.success("收货成功");
          this.getOrderList();
          if (type !== "confirmReceipt") {
            this.afterSalesConfirmReceiptTipDialogVisible = false;
            this.showDrawer = true;
          }
        })
        .catch(() => {
          // TODO: 错误处理
        });
    },

    goAfterSaleDetail(item) {
      if (item.rma_id) {
        this.$router.push({
          name: "afterSaleDetail",
          path: "/myaccount/afterSaleDetail",
          query: { rma_id: item.rma_id, id: item.order_no },
        });
      } else {
        this.goDetail(item);
      }
    }, // 关闭提示弹窗
    handleCloseTipDialog() {
      this.afterSalesExpiredTipDialogVisible = false;
      this.afterSalesConfirmReceiptTipDialogVisible = false;
    },

    //
    showPayUnknown(orderId) {
      if (orderId) this._currentOrder = orderId;
      // this.payStatus = 'unknown';
      this.$router.replace({
        path: `/myaccount/orderdetail?id=${this._currentOrder}`,
      });
    },
    //
    closePayUnknown() {
      this.payStatus = "";
      delete this._currentOrder;
      this.getOrderList();
    },
    //
    rePayment() {
      if (!this._currentOrder) return false;
      let item = this.orderList.find((item) => item.id == this._currentOrder);
      this.payStatus = "";
      delete this._currentOrder;
      item && this.toPay(item);
    },

    // 订单详情
    goDetail(info) {
      if (info.rma_id) {
        this.$router.push({
          name: "afterSaleDetail",
          path: "/myaccount/afterSaleDetail",
          query: { rma_id: info.rma_id, id: info.order_no },
        });
      } else {
        this.$router.push({
          name: "Orderdetail",
          query: { id: info.id },
        });
      }
    },
    goShopping() {
      this.$router.push({ path: "/" });
    },
    goBack() {
      this.$router.push({ path: "/account" });
    },
  },
  computed: {
    orderListItemButtonGroup() {
      return (item) => {
        const { status_code, rma_status_code, channel = "web" } = item;
        const ramGoods = utils.filterRamGoods(item);
        const sc = status_code || rma_status_code;
        return (
          utilsOrder.getOrderListItemButtonGroup({
            status_code: sc,
            is_rma: ramGoods.length > 0 ? 1 : 0,
            status: this.status,
            channel,
          })
        );
      };
    },
    calcQuantity() {
      return utils.calcQuantity;
    },
    isH5() {
      return window.innerWidth <= 768; // && (utils.isMobile() || utils.isWXBrowser());
    },
  },
};
</script>

<style lang="scss" scoped>
.orders {
  .dialog {
    width: 0;
    height: 0;

    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 1010;
      background: url(../../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      padding: 20px;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;

      .dialog-header {
        position: relative;
        text-align: left;
      }

      .dialog-body {
        display: flex;
      }
    }

    &.wait-pay {
      .dialog-container {
        width: 470px;
        height: 570px;

        .dialog-header {
          .dialog-close {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 20px;
            color: #999999;
            cursor: pointer;
            transform: rotate(45deg);
          }
        }

        .dialog-body {
          flex-direction: column;
          align-items: center;

          .pay-method {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 45px;

            .iconfont {
              font-size: 40px;

              &.ali-pay {
                color: rgb(0, 159, 233);
              }

              &.wx-pay {
                color: rgb(79, 163, 42);
              }
            }

            .pay-name {
              font-size: 20px;
              margin-left: 10px;
            }
          }

          .pay-amount {
            font-size: 14px;
            color: #666666;
            margin-top: 20px;

            .pay-value {
              font-size: 25px;
              color: #8b0013;
            }
          }

          .pay-hits {
            height: 40px;
            margin-top: 18px;

            .pay-countdown,
            .pay-msg {
              font-size: 14px;
              line-height: 20px;
              color: #666666;
              text-align: center;

              .countdown {
                color: #8b0013;
              }
            }
          }

          .pay-code {
            margin-top: 10px;
            position: relative;

            img {
              width: 190px;
              height: 190px;
            }

            .code-mask {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              z-index: 1;
              background: rgba(0, 0, 0, 0.5);
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              span {
                color: #fff;
              }
            }
          }

          .pay-method-tips {
            height: 40px;
            margin-top: 10px;

            .text {
              font-size: 14px;
              line-height: 20px;
              color: #333333;
              text-align: center;
            }
          }
        }
      }
    }

    &.pay-unknown {
      .dialog-container {
        width: 472px;
        height: 310px;

        .dialog-header {
          .dialog-close {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 20px;
            color: #999999;
            cursor: pointer;
            transform: rotate(45deg);
          }
        }

        .dialog-body {
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;

          .dialog-subtitle {
            font-size: 16px;
            color: #333333;
            font-weight: 700;
            margin-top: 40px;
          }

          .txt-line {
            font-size: 14px;
            color: #666666;

            &.mt20 {
              margin-top: 20px;
            }
          }

          .btn-group {
            margin-top: 28px;

            .btn {
              width: 100%;

              &:last-child {
                margin-top: 20px;
                color: #666666;
                background: #ffffff;
                border: 1px solid #e7e7e7;
              }
            }
          }
        }
      }
    }
  }

  .page-header {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e7e7e7;
    position: relative;
    display: none;

    .icon-back {
      color: #bcbcbc;
      line-height: 40px;
      width: 40px;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
    }

    .page-title {
      font-size: 13px;
      color: #333333;
      line-height: 40px;
      text-align: center;
    }
  }

  .swiper-tab {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666;
    font-size: 14px;
    margin-bottom: 20px;
    margin-top: 10px;

    .active {
      color: #333;
      // font-size: 18px;
      border-right: 1px solid #333;
    }

    .swiper-tab-list {
      padding: 0 32px;
      height: 100%;
      text-align: center;
      border-right: 1px solid #666;
      cursor: pointer;

      &:last-child {
        border-right: none;
      }
    }
  }

  .order-item {
    border: 1px solid #d2d2d2;
    margin-bottom: 20px;

    .order-title {
      display: flex;
      height: 40px;
      color: #333;
      align-items: center;
      border-bottom: 1px solid #d2d2d2;
      justify-content: flex-start;
      padding: 0 20px;

      .status span,
      .time {
        display: none;
      }

      .order-type {
        background: #f5f5f5;
        color: #8c8c8c;
        font-size: 10px;
        padding: 2px 4px;
        margin-right: 12px;
      }

      .left {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }

    .order-content {
      display: flex;
      flex-direction: column;
      padding: 20px;

      .order-info {
        padding-top: 0;
        flex-grow: 1;
        margin-right: 0;

        .goods-item {
          display: flex;
          justify-content: flex-start;
          margin-bottom: 20px;

          .item-img {
            width: 70px;
            height: 70px;
            box-sizing: border-box;
            padding: 2px;
            margin-right: 20px;
            border: 1px solid #dfdfdf;
            border-radius: 1px;
            flex-shrink: 0;
            display: flex;
            justify-content: center;
            align-content: center;
            position: relative;

            .goods-pic {
              width: 100%;
              // width: 66px;
              height: auto;
            }

            .order-status-babel {
              width: 100%;
              position: absolute;
              bottom: 0;
              left: 0;
              background: rgba(0, 0, 0, 0.5);
              color: #fff;
              font-size: 12px;
              text-align: center;
              line-height: 18px;
            }
          }

          .item-right {
            flex-grow: 0;

            .goods-info {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              width: 100%;

              .item-detail-brand {
                color: #BABEC2;
                font-weight: 700;
                font-size: 15px;
                margin-bottom: 2px;
              }

              .goods-size {
                display: flex;
                color: #999999;
                font-size: 14px;
                margin-top: 4px;
              }

              .goods-name {
                cursor: pointer;
                font-size: 14px;
                color: #333;
                text-align: left;
              }
            }

            .goods-row {
              display: flex;
              justify-content: space-between;
              flex: 1;
              margin-top: 4px;
            }
          }
        }
      }

      .order-summary {
        display: flex;
        flex-direction: row;
        gap: 20px;
        align-items: flex-start;

        .summary-item {
          color: #999999;
        }

        .price {
          color: #333;
        }
      }

      .order-status {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        padding-top: 24px;
        padding-left: 20px;
        gap: 10px;

        .pay,
        .cancel,
        .detail {
          // width: 100px;
          // height: 26px;
          // line-height: 26px;
          font-size: 12px;
          // box-sizing: border-box;
          // margin-bottom: 8px;
          cursor: pointer;
          // margin-right: 5px;
          border: 1px solid #212121;
          padding: 6px 20px;
        }

        .pay {
          border: 1px solid #7f0019;
          color: #ffffff;
          background: #7f0019;
        }

        .cancel,
        .detail {
          // border: 1px solid #e7e7e7;
          color: #666;
        }
      }
    }
  }

  .no-order {
    display: flex;
    border: 1px solid #d2d2d2;
    justify-content: space-between;
    align-items: center;
    height: 210px;
    padding: 0 80px;
    box-sizing: border-box;

    .no-info {
      display: flex;
      align-items: center;

      .icon-wrapper {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        background-color: #fbfbfb;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;

        .iconfont {
          font-size: 40px;
          color: #dfdfdf;
        }
      }

      .no-txt {
        display: flex;
        flex-direction: column;
        margin-left: 15px;

        .no-title {
          color: #333;
          font-size: 20px;
        }

        .no-subtitle {
          color: #666;
          font-size: 14px;
        }
      }
    }

    .buy {
      width: 100px;
      height: 26px;
      line-height: 26px;
      font-size: 12px;
      box-sizing: border-box;
      background: #7f0019;
      color: #fff;
      margin-bottom: 8px;
    }
  }

  .logistics-bottom {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;

    .logistics-btn {
      padding: 6px 20px;
      font-size: 12px;
      text-align: center;
      justify-content: flex-end;
      cursor: pointer;
    }

    .primary {
      background: #7f0019;
      color: #fff;
      border: 1px solid #7f0019;
    }

    .default {
      color: #666;
      border: 1px solid #000000;
    }
  }
}

@media only screen and (min-width: 768px) {
  .orders {
    .swiper-tab {
      overflow-x: auto;
    }

    .order-item {
      .order-title {
        display: flex;
        justify-content: flex-start;

        .id,
        .status {
          margin-right: 40px;
        }

        .status span,
        .time {
          display: inline-block;
        }
      }

      .order-content {
        justify-content: space-between;
        flex-direction: row;
        padding: 0 20px;

        .order-info {
          padding-top: 30px;
          padding-bottom: 30px;
          // flex-grow: 1;
          // margin-right: 30px;
          flex: 1;
          border-right: 1px solid #d2d2d2;

          .goods-item {
            .item-right {
              display: flex;
              flex: 1;

              .goods-info {
                display: flex;
                flex-direction: column;
                width: 60%;

                .goods-size {
                  display: flex;
                  color: #999999;
                  font-size: 14px;
                  margin-top: 4px;
                }
              }

              .goods-row {
                justify-content: flex-end;
                margin-top: 0;

                .price {
                  margin-left: 20px;
                  margin-right: 10px;
                }
              }
            }
          }
        }

        .order-status {
          // display: block;

          .pay {
            background: #7f0019;
            color: #fff;
          }

          .cancel {
            border: 1px solid #e7e7e7;
            color: #666;
          }

          .detail {
            color: #666;
            // text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }

    .no-order {
      display: flex;
      border: 1px solid #d2d2d2;
      justify-content: space-between;
      align-items: center;
      height: 210px;
      padding: 0 80px;
      box-sizing: border-box;

      .no-info {
        display: flex;

        .icon-wrapper {
          .iconfont {
            font-size: 40px;
            color: #dfdfdf;
          }
        }

        .no-txt {
          display: flex;
          flex-direction: column;

          .no-title {
            color: #333;
            font-size: 20px;
          }

          .no-subtitle {
            color: #666;
            font-size: 14px;
          }
        }
      }

      .buy {
        width: 100px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        box-sizing: border-box;
        background: #7f0019;
        color: #fff;
        margin-bottom: 8px;
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .orders {
    .page-header {
      display: block;
    }

    .swiper-tab {
      overflow-x: auto;
    }

    .order-item {
      .order-title {

        .id,
        .status {
          margin-right: 10px;
        }

        .status span,
        .time {
          display: inline-block;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .orders {
    .swiper-tab {
      overflow-x: auto;
    }

    .order-item .order-content .order-info .goods-item .item-right .goods-info {
      .item-detail-brand {
        color: #BABEC2;
        font-weight: 700;
        font-size: 10px;
        margin-bottom: 4px;
      }

    }

    .dialog.pay-unknown {
      .dialog-container {
        width: 285px;
        height: 225px;

        .dialog-body {
          .dialog-subtitle {
            margin-top: 8px;
          }

          .txt-line {
            font-size: 12px;
          }

          .btn-group {
            margin-top: 20px;

            .btn {
              width: 100%;

              &:last-child {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }

    .order-item {
      .order-title {
        justify-content: space-between;
        height: auto;

        justify-content: flex-start;
        flex-direction: column-reverse;
        gap: 4px;
        padding: 6px 20px;

        .left {
          justify-content: space-between;
          align-items: center;
          width: 100%;
          flex-direction: row-reverse;
          .order-type{
            margin-right: 0;
          }
        }

        .status {
          align-self: flex-start;
        }

        .status span,
        .time {
          display: none;
        }
      }

      .order-content {
        .order-status {
          flex-direction: row;
          justify-content: flex-end;
        }
      }
    }
  }
}

@media only screen and (min-width: 768px) {
  .logistics-bottom {
    flex-direction: column;
    padding-top: 24px;
    padding-left: 20px;
  }
}

@media only screen and (max-width: 768px) {
  .logistics-bottom {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .orders {
    .order-content {
      .logistics-content {
        display: flex;
        justify-content: space-between;

        .order-summary {
          flex-direction: column;
          gap: 2px;
        }
      }
    }
  }

  .orders {
    .swiper-tab {
      .swiper-tab-list {
        padding: 0 10px;
        font-size: 12px;

        &.active {
          font-size: 14px;
        }
      }
    }

    .no-order {
      height: auto;
      padding: 40px 30px;
      flex-direction: column;
      justify-content: flex-start;

      .no-info {
        flex-direction: column;

        .no-txt {
          margin: 20px 0 0 0;
        }
      }

      .buy {
        margin-top: 60px;
        width: 90%;
        height: 40px;
        line-height: 40px;
      }
    }
  }
}
</style>
